import React, { useEffect, useRef, useState } from "react";
// import Slider from "react-slick";
import Slider from "react-slick";
import Banner from "../Mandatory/Banner/Banner.js";

import Mandatory_14 from "../../../images/banners/90let_.jpg";
import Mandatory_15 from "../../../images/banners/dover_contact.jpg";
import Mandatory_2 from "../../../images/banners/Minzdrav_Poster_navigator_2qr.png";
import Mandatory_3 from "../../../images/banners/Sverdlovsk_region.jpg";
import Mandatory_4 from "../../../images/banners/dpk.jpg";
import Mandatory_5 from "../../../images/banners/qr.jpg";
import Mandatory_6 from "../../../images/banners/throwing.jpg";
import Mandatory_7 from "../../../images/banners/uslugi_dom.jpg";
import Mandatory_8 from "../../../images/banners/volonter2.jpg";
import Mandatory_9 from "../../../images/banners/road.jpg";
import Mandatory_10 from "../../../images/banners/qrcode.png";
import Mandatory_11 from "../../../images/banners/svo-tg-min.jpg";
import Mandatory_12 from "../../../images/banners/patient_safety_day_2026.png";
import Mandatory_13 from "../../../images/banners/NOKYOYMO.jpg";
import Mandatory_01 from "../../../images/banners/banner_protivodejstvie_korrupcii.jpg";
import Mandatory_16 from "../../../images/banners/QR-code.jpg";

const banners = [
  {
    image: Mandatory_01,
    link: "/about/anti-corruption",
  },
  { image: Mandatory_2, link: "https://www.takzdorovo.ru/" },
  { image: Mandatory_3, link: "https://midural.ru/news/101067/" },
  { image: Mandatory_4, link: "https://vk.ru/dpk_so" },
  { image: Mandatory_5, link: "https://vk.ru/public218001479" },
  { image: Mandatory_6, link: "https://www.takzdorovo.ru/" },
  { image: Mandatory_7, link: "https://dom.gosuslugi.ru/" },
  { image: Mandatory_8, link: "https://премия.мывместе.рф/" },
  { image: Mandatory_9, link: "https://екб.66.мвд.рф/news/item/29572023" },
  { image: Mandatory_10, link: "https://t.me/minzdravso" },
  { image: Mandatory_11, link: "https://t.me/+-NlCAoiZghk2OTNi" },
  {
    image: Mandatory_12,
    link: "https://nqi-russia.ru/event/konferentsii/vsemirnyy-den-bezopasnosti-patsienta-2026/",
  },
  {
    image: Mandatory_13,
    link: "https://anketa.minzdrav.gov.ru/ambulator/2170c959-4e72-4d32-9a88-4d8ab66bfa0a/b7828a72-863b-40cb-8f8f-b9ab89d23bc1",
  },
  { image: Mandatory_14, link: "https://све.рф/news/28141" },
  ,
  {
    image: Mandatory_15,
    link: "https://www.gosuslugi.ru/landing/trusted_contact",
  },
  {
    image: Mandatory_16,
    link: "https://pos.gosuslugi.ru/lkp/polls/preview/608994/?id=608994&hash=fe6167630c66393cd73c6a85d253cd5f&expired_at=1780575681",
  },
];

export default function Reviews() {
  const sliderRef = useRef(null);

  const getVisibleCards = () => {
    const width = window.innerWidth;
    if (width < 768) return 1;
    if (width < 1024) return 2;
    return 4;
  };

  const [visibleCards, setVisibleCards] = useState(getVisibleCards());

  useEffect(() => {
    const handleResize = () => {
      setVisibleCards(getVisibleCards());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      sliderRef.current?.slickNext();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: visibleCards,
    autoplay: false,
  };

  return (
    <section className="mandatory">
      <button
        className="prevention__left mandatory__left"
        onClick={() => sliderRef.current?.slickPrev()}
      ></button>

      <button
        className="prevention__right mandatory__right"
        onClick={() => sliderRef.current?.slickNext()}
      ></button>

      <div className="employees__slider mandatory__slider">
        <Slider ref={sliderRef} {...settings}>
          {banners.map((banner, i) => (
            <Banner key={i} image={banner.image} link={banner.link} />
          ))}
        </Slider>
      </div>
    </section>
  );
}
